import { render, staticRenderFns } from "./TrainingFaq.vue?vue&type=template&id=eb55572a&scoped=true&"
import script from "./TrainingFaq.vue?vue&type=script&lang=js&"
export * from "./TrainingFaq.vue?vue&type=script&lang=js&"
import style0 from "./TrainingFaq.vue?vue&type=style&index=0&id=eb55572a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb55572a",
  null
  
)

export default component.exports